import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import type { Maybe } from '@/lib/types';
import { theme } from '@/theme';

import { getImageAndBackgroundStyles } from '../commonStyles.styles';

export const Header = styled(Box)<{
  $backgroundColorOpacity: Maybe<string>;
  backgroundColor: Maybe<string>;
  backgroundImage: Maybe<string>;
}>`
  padding: ${({ theme }) => theme.spacing(1, 0)};

  height: 317px;
  isolation: isolate;

  ${({ backgroundImage }) =>
    backgroundImage &&
    css`
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    `}

  ${({ $backgroundColorOpacity, backgroundColor, backgroundImage }) =>
    getImageAndBackgroundStyles(
      $backgroundColorOpacity,
      backgroundColor,
      backgroundImage,
    )} 

  ${theme.media.md.up} {
    height: 296px;
  }
`;

export const Heading = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  min-height: 296px;

  ${({ theme }) => css`
    ${theme.media.md.up} {
      min-height: 276px;
    }
  `}
`;
